import {Timer} from "js-vextensions";
import {observer_mgl} from "mobx-graphlink";
import React, {useEffect} from "react";
import {Column, Row} from "react-vcomponents";
import {useForceUpdate} from "web-vcore";
import {GetLiveSession_Reactive} from "../../../../Engine/LiveSessionManagement.js";

export const SessionInfoUI = observer_mgl(()=>{
	return <SessionCompsStatusUIContainer/>;
});

export const SessionCompsStatusUIContainer = observer_mgl((props: {refreshInterval?: number})=>{
	const {refreshInterval = 1000} = props;
	const forceUpdate = useForceUpdate();

	// update once per second (in case status-ui responses from session comps change)
	useEffect(()=>{
		const timer = new Timer(refreshInterval, ()=>{
			forceUpdate();
		}).Start();
		return ()=>timer.Stop();
	});

	const liveSession = GetLiveSession_Reactive();
	if (liveSession == null) return null;

	return (
		<Column>
			{liveSession.components.map((comp, index)=>{
				if (comp.GetStatusUI == null) return null;
				const statusUI_raw = comp.GetStatusUI();
				const wrapper = typeof statusUI_raw == "object" && statusUI_raw != null && "ui" in statusUI_raw
					? statusUI_raw
					: {ui: statusUI_raw as n|string|React.JSX.Element, omitWrapper: false};
				if (wrapper.ui == null) return null; // if no status UI, skip

				// if no wrapper needed, return directly (well, other than in a keyed fragment, to avoid React warnings)
				if (wrapper.omitWrapper) return <React.Fragment key={index}>{wrapper.ui}</React.Fragment>;
				// else, return wrapped in a column
				return <React.Fragment key={index}>
					<Row mt={5}>{comp.constructor.name.replace("Comp", "")}...</Row>
					<Column mt={5} ml={10}>
						{wrapper.ui}
					</Column>
				</React.Fragment>;
			})}
		</Column>
	);
});